'use client';
/** @jsxImportSource @emotion/react */

import type { FadeProps } from '@mui/material/Fade';

import MuiFade from '@mui/material/Fade';

export type { FadeProps };
export const Fade: React.FC<FadeProps> = MuiFade;

Fade.displayName = 'Fade';
